import React from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Box,
  Avatar,
  Divider,
  Stack,
  Tooltip,
  IconButton,
  Link,
  Button,
} from "@mui/material";
import {
  AccessTime,
  CalendarToday,
  Assignment,
  Group,
  Flag,
  Info,
  ArrowBack,
  InsertDriveFile,
} from "@mui/icons-material";
import { BASE_URL } from "../Utils/Baseurl";

const InfoItem = ({ label, value, icon }) => (
  <Grid item xs={12} sm={6} md={4}>
    <Stack direction="row" spacing={1} alignItems="flex-start">
      {icon}
      <Box>
        <Typography variant="caption" color="textSecondary">
          {label}
        </Typography>
        <Typography variant="body2" fontWeight={500}>
          {value || "N/A"}
        </Typography>
      </Box>
    </Stack>
  </Grid>
);

const StakeHolderView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location?.state;

  const renderAttachment = (url) => {
    const fileName = url?.split("/").pop();
    const extension = fileName?.split(".").pop()?.toLowerCase();
    if (!extension) return null;

    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(extension);
    const isPDF = extension === "pdf";
    const isWord = ["doc", "docx"].includes(extension);

    if (isImage) {
      return (
        <Box mt={1}>
          <img
            src={url}
            alt="Attachment"
            style={{
              maxWidth: 300,
              height: "auto",
              borderRadius: 6,
              boxShadow: "0 1px 5px rgba(0,0,0,0.1)",
            }}
          />
        </Box>
      );
    }

    if (isPDF) {
      return (
        <Box mt={1}>
          <iframe
            src={url}
            title="PDF Attachment"
            width="100%"
            height="400px"
            style={{ border: "none", borderRadius: 6 }}
          />
        </Box>
      );
    }

    const label = isWord ? "View Word Document" : "Download Attachment";
    return (
      <Box mt={1}>
        <Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          <Chip
            icon={<InsertDriveFile />}
            label={label}
            color={isWord ? "primary" : "secondary"}
            clickable
            size="small"
          />
        </Link>
      </Box>
    );
  };

  return (
    <DashboardLayout>
      <Box px={2} py={3}>
        <IconButton onClick={() => navigate(-1)} color="primary" sx={{ mb: 2 }}>
          <ArrowBack />
        </IconButton>

        <Card elevation={3}>
          <CardContent>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              📝 Task: {data?.task_title}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" gutterBottom>
              {data?.task_describtion || "No description provided."}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Grid container spacing={2}>
              <InfoItem
                label="Assignee"
                value={data?.assignee}
                icon={<Assignment fontSize="small" />}
              />
              <InfoItem
                label="Task code"
                value={data?.task_code}
                icon={<Assignment fontSize="small" />}
              />
              <InfoItem
                label="Assigned Hours"
                value={data?.assigned_hours}
                icon={<AccessTime fontSize="small" />}
              />
              <InfoItem
                label="Actual Hours"
                value={data?.actual_hours}
                icon={<AccessTime fontSize="small" />}
              />
              <InfoItem
                label="Start Date"
                value={data?.start_date}
                icon={<CalendarToday fontSize="small" />}
              />
              <InfoItem
                label="End Date"
                value={data?.end_date}
                icon={<CalendarToday fontSize="small" />}
              />
              <InfoItem
                label="Priority"
                value={
                  <Chip
                    icon={<Flag />}
                    label={data?.priotiy}
                    color="error"
                  />
                }
                icon={<Flag fontSize="small" />}
              />
              <InfoItem
                label="Team"
                value={data?.teams}
                icon={<Group fontSize="small" />}
              />
              <InfoItem
                label="Module"
                value={data?.module}
                icon={<Info fontSize="small" />}
              />
              <InfoItem
                label="Milestone"
                value={data?.milestone_name}
                icon={<Info fontSize="small" />}
              />
              {/* <InfoItem
                label="Sprint"
                value={data?.sprint_number}
                icon={<Info fontSize="small" />}
              /> */}
              <InfoItem
                label="Project"
                value={data?.project_name}
                icon={<Info fontSize="small" />}
              />
              <InfoItem
                label="Created By"
                value={data?.created_by}
                icon={<Assignment fontSize="small" />}
              />
              <InfoItem
                label="Status"
                value={
                  <Chip label={data?.status || "Not Updated"} color="primary" />
                }
                icon={<Info fontSize="small" />}
              />
            </Grid>

            {/* Attachment Viewer */}
            {data?.attachment && (
              <Box mt={3}>
                <Typography variant="subtitle2" gutterBottom>
                  📎 Attachment
                </Typography>
                {renderAttachment(`${BASE_URL}${data.attachment}`)}
              </Box>
            )}

            {/* Stakeholders */}
            {Array.isArray(data?.stake_holder) && (
              <Box mt={4}>
                <Typography variant="subtitle2" gutterBottom>
                  👥 Stakeholders
                </Typography>
                <Grid container spacing={1}>
                  {data?.stake_holder.map((s, index) => (
                    <Grid item key={index}>
                      <Tooltip title={s.user_name || `User ${index + 1}`}>
                        <Chip
                          avatar={<Avatar>{s.user_name?.[0] || "U"}</Avatar>}
                          label={s.user_name || `User ${index + 1}`}
                          variant="outlined"
                          icon={<Group />}
                          color="secondary"
                        />
                      </Tooltip>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    </DashboardLayout>
  );
};

export default StakeHolderView;
